import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Calendar/availability. This could be any groomer or current providers location.
  selectedGroomer: {},
  suggestions: [],
  isFetching: false,
  requestLoading: false,
  drawer: {
    isOpen: false,
    type: '',
    uuid: null,
    data: null,
    position: '',
  },
  checkoutSuccessModal: {
    isOpen: false,
    user: {
      firstName: null,
      lastName: null,
    },
    service: {
      name: null,
      amount: null,
    },
  },
  appointmentActionsModal: {
    isOpen: false,
    data: {
      appointment: null,
      title: null,
      description: null,
      status: null,
    },
  },
};

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    geoLocationsRequest(state, { payload }) {
      state.isFetching = true;
    },
    geoLocationsSuccess(state, { payload }) {
      const suggestions = [];
      if (payload.data?.[0]) {
        Object.entries(payload.data[0]).forEach(([id, data]) => {
          suggestions.push(data.map((el) => ({ ...el, dataType: id })));
        });
      }

      state.isFetching = false;
      state.suggestions = suggestions.flat();
    },
    requestOngoing(state) {
      state.requestLoading = true;
    },
    requestFulfilled(state) {
      state.requestLoading = false;
    },
    geoLocationsFailure(state) {
      state.isFetching = false;
    },
    openDrawer(state, { payload }) {
      const {
        uuid = null,
        type = null,
        position = null,
        data = null,
      } = payload;
      state.drawer = {
        isOpen: true,
        type,
        uuid,
        data,
        position,
      };
    },
    closeDrawer(state) {
      state.drawer.isOpen = false;
    },
    toggleCheckoutSuccessModal(state, { payload }) {
      const { isOpen, user, service } = payload;
      state.checkoutSuccessModal = {
        isOpen,
        user,
        service,
      };
    },
    setSelectedGroomer(state, { payload }) {
      state.selectedGroomer = payload;
    },
    openAppointmentActionsModal(state, { payload }) {
      state.appointmentActionsModal = {
        isOpen: true,
        data: payload.modalData,
      };
    },
    closeAppointmentActionsModal(state) {
      state.appointmentActionsModal = initialState.appointmentActionsModal;
    },
  },
});

const { actions, reducer } = ui;

export const {
  geoLocationsRequest,
  geoLocationsSuccess,
  geoLocationsFailure,
  requestOngoing,
  requestFulfilled,
  openDrawer,
  closeDrawer,
  toggleCheckoutSuccessModal,
  setSelectedGroomer,
  openAppointmentActionsModal,
  closeAppointmentActionsModal,
} = actions;

export default reducer;
